import { ColorAction } from '@jimp/plugin-color';
import { default as jimp, default as Jimp } from "jimp";
import * as React from "react";

export interface IImageFilter {
    filter: (filter: number) => void;
}

export interface IImageFilterProps {
    src: string; // image to apply the filter
    onPreview: (src: string) => void;
    setImageFilter?: (crop: IImageFilter) => void;
    setFilterToolIcons(icons: [string, string][]): void;
    loading: () => void;
}

interface IImageFilterState {
}

interface IImageFilterPreset {
    type: "color" | "blur" | "greyscale" | "sepia" | "contrast" | "posterize" | "invert",
    colorAction?: ColorAction[],
    value?: number
}

interface IImageFilterCollectionPreset {
    name: string,
    filter: IImageFilterPreset[]
}
export default class ImageFilter extends React.Component<IImageFilterProps, IImageFilterState> {

    private filterPresets: IImageFilterCollectionPreset[] = [
        {
            name: "hue",
            filter: [
                {
                    type: "color",
                    colorAction:
                        [{ apply: 'hue', params: [-90] }]
                }
            ]
        },
        {
            name: "blur",
            filter: [
                {
                    type: "blur",
                    value: 2,
                }
            ]
        },
        {
            name: "contrast",
            filter: [
                {
                    type: "contrast",
                    value: 0.2,
                },
            ]
        },
        {
            name: "sepia",
            filter: [
                {
                    type: "sepia"
                }
            ]
        },
        {
            name: "greyscale",
            filter: [
                {
                    type: "greyscale"
                },
            ]
        },
        {
            name: "vintage",
            filter: [
                {
                    type: "sepia"
                },
                {
                    type: "contrast",
                    value: 0.1,
                },
                {
                    type: "color",
                    colorAction:
                        [{ apply: 'red', params: [30] }]
                }
            ]
        },
        {
            name: "posterize",
            filter: [
                {
                    type: "posterize",
                    value: 10
                },
            ]
        },
        {
            name: "invert",
            filter: [
                {
                    type: "invert",
                },
            ]
        },
        {
            name: "red_shift",
            filter: [
                {
                    type: "color",
                    colorAction:
                        [{ apply: 'red', params: [30] }]
                },
            ]
        },
        {
            name: "green_shift",
            filter: [
                {
                    type: "color",
                    colorAction:
                        [{ apply: 'green', params: [30] }]
                },
            ]
        },
        {
            name: "blue_shift",
            filter: [
                {
                    type: "color",
                    colorAction:
                        [{ apply: 'blue', params: [30] }]
                },
            ]
        },
    ];

    constructor(props: IImageFilterProps) {
        super(props);
        this.state = {
        }
        if (this.props.setImageFilter)
            this.props.setImageFilter(this);
        this.autogenenThumbs();
    }

    public render() {
        return (null);
    }

    private autogenenThumbs = async () => {
        const thumbUrl = await jimp.read(this.props.src)
            .then((image) => image.resize(50, jimp.AUTO))
            .then((image) => this.imageToUrl(image));

        const thumbColletion: [string, string][] = [];

        for (let filterPreset of this.filterPresets) {
            const previewImgUrl = await jimp.read(thumbUrl)
                .then((image) => this.applyFilterCollection(filterPreset, image))
                .then((image) => this.imageToUrl(image));
            thumbColletion.push([filterPreset.name, previewImgUrl]);
        }

        this.props.setFilterToolIcons(thumbColletion);
    }

    private applyFilterCollection = async (filterPreset: IImageFilterCollectionPreset, image: Jimp) => {
        return new Promise((resolve: (val: Jimp) => void) => {
            for (let filter of filterPreset.filter) {
                this.applyFilter(filter, image);
            }
            resolve(image);
        });
    }

    private applyFilter = async (filter: IImageFilterPreset, image: Jimp) => {
        return new Promise((resolve: (val: Jimp) => void) => {
            switch (filter.type) {
                case "color":
                    if (filter.colorAction)
                        image.color(filter.colorAction);
                    resolve(image);
                    break;
                case "blur":
                    if (filter.value)
                        image.blur(filter.value);
                    resolve(image);
                    break;
                case "contrast":
                    if (filter.value)
                        image.contrast(filter.value);
                    resolve(image);
                    break;
                case "greyscale":
                    image.grayscale();
                    resolve(image);
                    break;
                case "sepia":
                    image.sepia();
                    resolve(image);
                    break;
                case "posterize":
                    if (filter.value)
                        image.posterize(filter.value);
                    resolve(image);
                    break;
                case "invert":
                    image.invert();
                    resolve(image);
                    break;
            }
        });
    }

    private imageToUrl = async (image: Jimp) => {
        return await image.getBase64Async("image/jpeg")
            .then((data) => fetch(data))
            .then((base64) => base64.blob())
            .then((blob) => URL.createObjectURL(blob));
    }

    public filter = async (filter: number) => {
        this.props.loading();
        const image = await jimp.read(this.props.src)
            .then((image) => this.applyFilterCollection(this.filterPresets[filter], image))
            .then((image) => this.imageToUrl(image));
        this.props.onPreview(image);
    }

}

// private colorFilterPresets: IImageFilterPreset[] = [
//     {
//         type: "color",
//         colorAction:
//             [{ apply: 'hue', params: [-90] }]
//     },
//     {
//         type: "color",
//         colorAction:
//             [{ apply: 'red', params: [40] }]
//     },
//     {
//         type: "color",
//         colorAction:
//             [{ apply: 'green', params: [40] }]
//     },
//     {
//         type: "color",
//         colorAction:
//             [{ apply: 'blue', params: [40] }]
//     },
//     {
//         type: "blur",
//         value: 5,
//     },
//     {
//         type: "contrast",
//         value: 0.3,
//     },
//     {
//         type: "greyscale"
//     },
//     {
//         type: "sepia"
//     },

// ];

